<template>
  <el-dialog
    class="dialog-wrapper thermostats-log"
    visible
    show-close
    @close="$emit('dialogClose')"
  >
    <ContentHeader
      slot="title"
      :title="$t('thermostats.log.title')"
    />
    <div class="table-wrapper">
      <el-table
        class="width-100"
        :data="temperatures"
        border
      >
        <el-table-column :label="$t('thermostats.log.startDate')">
          <template slot-scope="scope">
            {{ scope.row.createdAt | datetime }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('thermostats.log.endDate')">
          <template slot-scope="scope">
            <span v-if="scope.row.closedAt">
              {{ scope.row.closedAt | datetime }}
            </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('thermostats.log.configuredTemperature')">
          <template slot-scope="scope"> {{ scope.row.value }} ˚C </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  import { thermostatsApi } from '@/api';
  import ContentHeader from '@/components/ContentHeader.vue';

  export default {
    name: 'TemperatureLog',
    components: {
      ContentHeader,
    },
    props: {
      thermostatId: { type: Number, required: true },
    },
    data() {
      return {
        temperatures: [],
      };
    },
    async created() {
      try {
        const response = await thermostatsApi.getTemperatures(
          this.thermostatId
        );
        this.temperatures = response.data;
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: error.response.data.error.message,
        });
      }
    },
  };
</script>
